import {
  DateTime
} from 'luxon';
import TimeRange from '../getTimeRange';
import mergeObj from '../extraUtil/mergeTwoObj';
const dateTimeHashMap = new TimeRange().dateTimeHashMap;

let chart = {
  "showXAxisLine": "0",
  "showyaxisline": "0",
  "xAxisLineThickness": "1",
  "xAxisLineColor": "#BEB2C8",
  "paletteThemeColor": "#DCDCDD",
  "plotfillalpha": "100",
  "resizeAnimDuration": "0",
  "showhighlowvalue": "0",
  "lineThickness": "1",
  "updateAnimDuration": "0",
  "showhighanchor": "0",
  "showlowanchor": "0",
  "showopenvalue": "0",
  "showclosevalue": "0",
  "chartBottomMargin": "0",
  "chartLeftMargin": "10",
  "chartRightMargin": "10",
  "chartTopMargin": "0"
}

export default function dataSourceGenerator(rawData, timeSelectorValue, theme) {
  chart = mergeObj(chart, theme);
  let dataSource = {},
    dataset = [],
    data = [],
    startDate = dateTimeHashMap[timeSelectorValue]['startDate'],
    endDate = dateTimeHashMap[timeSelectorValue]['endDate'],
    startDateInDateTime = DateTime.fromFormat(startDate, 'M/d/yy H:mm'),
    endDateInDateTime = DateTime.fromFormat(endDate, 'M/d/yy H:mm'),
    diffInDays = Math.floor(endDateInDateTime.diff(startDateInDateTime, 'days').values.days),
    shipmentCount = new Array(diffInDays + 1).fill(0);
  for (let i = 0; i < rawData.length; i++) {
    let numberOfDaysFromStart = Math.floor(DateTime.fromMillis(rawData[i]['expectedShipDate'], 'M/d/yy H:mm').diff(startDateInDateTime, 'days').values.days);
    shipmentCount[numberOfDaysFromStart] += 1;
  }
  for (let j = 1; j < shipmentCount.length; j++) {
    let date = DateTime.fromMillis(startDateInDateTime + (j * 86400000)).toFormat('d-MMM-yyyy');
    if (shipmentCount[j]) {
      data.push({
        value: shipmentCount[j],
        tooltext: "Date: " + date + "<br>Value: " + shipmentCount[j]
      });
    }
  }
  dataset.push({
    data: data
  });
  dataSource = {
    chart: chart,
    dataset: dataset
  }
  return dataSource
}


// WEBPACK FOOTER //
// ./src/util/dataSourceGenerators/shipmentCountGenerator.js